import { MockSimpleXdmExtension } from "./MockSimpleXdmExtension";
/**
 * This class provides a mock implementation of ConnectHost.
 */
var MockConnectHost = /** @class */ (function () {
    function MockConnectHost() {
        this.onIframeEstablished = jest.fn();
        this.offIframeEstablished = jest.fn();
        this.onIframeUnload = jest.fn();
        this.offIframeUnload = jest.fn();
        this.createExtension = jest.fn(function (params) {
            var val = new MockSimpleXdmExtension;
            val.iframeAttributes.src = params.url;
            return val;
        });
        this.destroy = jest.fn();
        this.getContentResolver = jest.fn();
        this.hasJwt = jest.fn();
        this.isJwtExpired = jest.fn();
    }
    return MockConnectHost;
}());
export { MockConnectHost };
//# sourceMappingURL=MockConnectHost.js.map